// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc746d90","453":"c6f4b3a1","455":"90b74c96"}[chunkId] + ".chunk.js";
};